import type { IGroupInfo } from '@/api/types/product';
import { getLegacyRichTextPlainText } from './legacyRichText.utils';

const normalizeText = (value: unknown): string => (typeof value === 'string' ? value.trim() : '');

/** 保持 Footer 的现有过滤/顺序/空答案契约，不去重、不截断。 */
export function normalizeGoodsListFaq(value: unknown): NonNullable<IGroupInfo['faq_list']> {
  if (!Array.isArray(value)) return [];
  return value.flatMap((item: unknown) => {
    if (!item || typeof item !== 'object' || !('question' in item)) return [];
    const question = normalizeText(item.question);
    if (!question) return [];
    return [{ question, answer: normalizeText('answer' in item ? item.answer : undefined) }];
  });
}

/** 仅发布正文中有可读问题和答案的条目；安全文本与 UI 共用解析器。 */
export function createGoodsListFaqSchema(items: NonNullable<IGroupInfo['faq_list']>) {
  const mainEntity = items.flatMap(({ question, answer }) => {
    const name = getLegacyRichTextPlainText(question);
    const text = getLegacyRichTextPlainText(answer);
    return name && text
      ? [{ '@type': 'Question', name, acceptedAnswer: { '@type': 'Answer', text } }]
      : [];
  });
  return mainEntity.length
    ? { '@context': 'http://schema.org', '@type': 'FAQPage', mainEntity }
    : null;
}
